import { Truncate } from '@labrav/react-components'
import { Grid } from '@mui/material'
import { useStyles } from './PlanRow.styles'
import { AzureOfferPlan } from '../../../../../modules/privateOffer/reducer'
import { DisplayValueData } from '../../../../PrivateOfferFormV2/AzureOffer/Plan/PlanRow/MeteringDimensions/MeteringDimensions'
import {
  Product,
  ProductPlan,
} from '../../../../../modules/productsListing/reducer'

export const PlanRowValues = ({
  plan,
  product,
}: {
  plan: AzureOfferPlan
  index: number
  product: Product
}) => {
  const { classes } = useStyles()

  const selectedProductPlan = product?.plans?.find(
    planItem => planItem?.planId === plan?.labraPlanId
  ) as ProductPlan

  const originalTcvValue =
    selectedProductPlan?.pricing?.[0]?.pricePerPaymentInUsd

  return (
    <>
      <Grid size={4}>
        <div className={classes.title}>Description</div>
        <div className={classes.content}>
          <Truncate showIcon={false} clipboardTooltip>
            {plan.description}
          </Truncate>
        </div>
      </Grid>
      <Grid size={4}>
        <div className={classes.title}>Public price</div>
        <div className={classes.content}>
          <DisplayValueData
            isPrice
            id="tcvValue"
            value={originalTcvValue}
            precision={5}
          />
        </div>
      </Grid>
    </>
  )
}
